import { DragulaModule } from 'ng2-dragula';

import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { TelerecourspnrSharedModule } from '../shared';
import { DraftModalComponent } from '../shared/components/draft-modal/draft-modal.component';
import { DepotRequeteComponent } from './depot-requete.component';
import { DEPOT_REQUETE_ROUTE } from './depot-requete.route';
import { DraftDepotRequeteService } from './draft-depot-requete.service';
import { DraftRequeteResolver } from './draft-requete.resolver';
import { LoadDraftComponent } from './load-draft.component';
import {
  ActeAttaqueComponent, ReclamationPrealableComponent, AddedRequerantComponent, AddRequerantHeaderComponent, AddRequerantSectionComponent,
  AvertissementComponent, EditFormComponent, JuridictionComponent, JuridictionSectionComponent, RequeteComponent,
  UrgenceRequeteSectionComponent, ContentieuxSocialSectionComponent, JustificatifsComponent,
  RecapitulatifComponent, RequerantsComponent, RequerantTypeSectionComponent, ResultFormComponent, SearchFormComponent,
  SiteJuridictionSectionComponent, TypeActeAttaqueAvertissementComponent, TypeActeAttaqueInfoComponent,
  TypeActeAttaqueSectionComponent
} from './steps';
import { A11yModule } from '@angular/cdk/a11y';

@NgModule({
    imports: [
        A11yModule,
        DragulaModule,
        TelerecourspnrSharedModule,
        RouterModule.forRoot([DEPOT_REQUETE_ROUTE], { useHash: true })
    ],
    declarations: [
        DepotRequeteComponent,
        AvertissementComponent,
        RequerantsComponent,
        JuridictionComponent,
        RequeteComponent,
        UrgenceRequeteSectionComponent,
        ContentieuxSocialSectionComponent,
        JustificatifsComponent,
        RecapitulatifComponent,
        JuridictionSectionComponent,
        SiteJuridictionSectionComponent,
        TypeActeAttaqueSectionComponent,
        TypeActeAttaqueInfoComponent,
        TypeActeAttaqueAvertissementComponent,
        RequerantTypeSectionComponent,
        AddRequerantSectionComponent,
        SearchFormComponent,
        ResultFormComponent,
        AddedRequerantComponent,
        EditFormComponent,
        AddRequerantHeaderComponent,
        ActeAttaqueComponent,
        ReclamationPrealableComponent,
        LoadDraftComponent,
    ],
    entryComponents: [DraftModalComponent],
    providers: [DraftDepotRequeteService, DraftRequeteResolver]
})
export class TelerecourspnrDepotRequeteModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/depot-requete/depot-requete.module.ts